import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTA = () => (
  <section data-testid="final-cta-section" className="bg-white py-16 sm:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-[#191512] px-6 sm:px-12 py-14 sm:py-20 text-center shadow-2xl">
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#c8102e]/20" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-[#1b7a46]/15" />
          <span className="watermark-text absolute inset-x-0 top-1/2 -translate-y-1/2 text-[12vw] text-white/[0.04]">Senza pensieri</span>
          <div className="relative">
            <h2 className="font-condensed font-black uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Inizia oggi a vivere
              <span className="block text-[#c8102e]">senza pensieri</span>
            </h2>
            <p className="mt-5 text-white/80 text-base sm:text-lg max-w-xl mx-auto">
              Bastano pochi minuti per attivare il tuo abbonamento.
              La cura di casa e ufficio non è mai stata così semplice.
            </p>
            <a
              href="#pacchetti"
              data-testid="final-cta-button"
              className="mt-9 inline-flex items-center gap-2 bg-[#c8102e] hover:bg-[#a50d26] text-white font-semibold px-9 py-4 rounded-full shadow-lg shadow-[#c8102e]/40 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
            >
              Scegli il tuo pacchetto
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
